export default function StakeInfo({ unstackAmount }: { unstackAmount: string }) {
  return (
    <div className="rounded-3xl border border-zinc-800 bg-[#111113] p-8">

      <p className="uppercase text-zinc-500 tracking-[3px] text-xs">
        Dein Gestaktes Vermögen
      </p>

      <h1 className="text-6xl font-bold mt-5">
        {unstackAmount}
        <span className="text-red-500 text-3xl ml-2">
          BCT
        </span>
      </h1>

      <p className="text-zinc-500 mt-2">
        Vollständig verfügbar zum Unstake
      </p>

      <div className="border-t border-zinc-800 my-8" />

      <div className="space-y-4 text-sm">

        <div className="flex justify-between">
          <span className="text-zinc-500">
            Programm beendet am
          </span>

          <span>
            16.06.2026, 23:59 UTC
          </span>
        </div>

        <div className="flex justify-between">
          <span className="text-zinc-500">
            Staking-Vertrag
          </span>

          <span>0xB1C7...4F2A</span>
        </div>

        <div className="flex justify-between">

          <span className="text-zinc-500">
            Status
          </span>

          <span className="bg-red-600/20 text-red-500 px-4 py-1 rounded-full text-xs">
            Nur Unstake möglich
          </span>

        </div>

      </div>

    </div>
  );
}